import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-search-filters-toggles',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ng-content></ng-content>`
})
export class SearchFiltersTogglesComponent {
}
